/**
 * Map Role Code To Text.
 * @param code - String mapping code.
 * @param resources - Translation keys.
 * @return - Role as fulltext string
 */

export const mapRoleCodeToText = (code: string, resources: any): string => {
    switch (code) {
        case 'Z5':
            return resources.contactPageRoleCustomerServiceRepresentative;
        case 'Z6':
            return resources.contactPageRoleSalesRepresentative;
        default:
            return resources.contactPageRoleNotFoundError;
    }
};
